import { APP_NAME, DEFAULT_VIEW, findView } from "../nav";

// Operational page header: breadcrumb, H1, concise description, then actions.
export default function PageHead({ viewId, description, actions }) {
  const view = findView(viewId);
  return (
    <div className="pagehead">
      <div className="pagehead__row">
        <div>
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <a href={`#/${DEFAULT_VIEW}`}>{APP_NAME}</a>
            <span aria-hidden="true">/</span>
            <span>{view.group}</span>
            <span aria-hidden="true">/</span>
            <span aria-current="page">{view.label}</span>
          </nav>
          <h1>{view.label}</h1>
          {description && <p className="pagehead__desc">{description}</p>}
        </div>
        {actions && <div className="pagehead__actions">{actions}</div>}
      </div>
    </div>
  );
}
